import { Axes, ThemeData } from '@y42/json-schema';

export function createAxes(type: Axes['type'] = ''): Axes {
  return {
    type,
    name: '',
    axisLineShow: true,
    axisLineColor: '',
    axisLineWidth: 0,
    axisTickShow: true,
    axisTickColor: '',
    axisLabelShow: true,
    axisLabelColor: '',
    splitLineShow: true,
    splitLineColor: [''],
    splitLineWidth: 0,
    splitAreaShow: false,
    splitAreaColor: [''],
  };
}

export function createThemeData(): ThemeData {
  return {
    themeName: '',
    seriesCnt: 1,
    backgroundColor: '',
    frameBackgroundColor: '',
    frameBorderColor: '',
    frameBorderWidth: 0,
    titleColor: '',
    subtitleColor: '',
    textColorShow: true,
    textColor: '',
    markTextColor: '',
    color: [''],
    borderColor: '',
    borderWidth: 0,
    visualMapColor: [''],
    legendTextColor: '',
    kColor: '',
    kColor0: '',
    kBorderColor: '',
    kBorderColor0: '',
    kBorderWidth: 0,
    lineWidth: 0,
    symbolSize: 0,
    symbol: '',
    symbolBorderWidth: 0,
    lineSmooth: true,
    graphLineWidth: 0,
    graphLineColor: '',
    mapLabelColor: '',
    mapLabelColorE: '',
    mapBorderColor: '',
    mapBorderColorE: '',
    mapBorderWidth: 0,
    mapBorderWidthE: 0,
    mapAreaColor: '',
    mapAreaColorE: '',
    axes: [],
    axisSeperateSetting: true,
    toolboxColor: '',
    toolboxEmphasisColor: '',
    tooltipAxisColor: '',
    tooltipAxisWidth: 0,
    timelineLineColor: '',
    timelineLineWidth: 0,
    timelineItemColor: '',
    timelineItemColorE: '',
    timelineCheckColor: '',
    timelineCheckBorderColor: '',
    timelineItemBorderWidth: 0,
    timelineControlColor: '',
    timelineControlBorderColor: '',
    timelineControlBorderWidth: 0,
    timelineLabelColor: '',
    datazoomBackgroundColor: '',
    datazoomDataColor: '',
    datazoomFillColor: '',
    datazoomHandleColor: '',
    datazoomHandleWidth: '',
    datazoomLabelColor: '',
    agGridMaterialPrimaryColor: '',
    agGridMaterialAccentColor: '',
    agGridForegroundColor: '',
    cohortPrimaryColor: '#62BE7B',
    cohortSecoundaryColor: '#F8696B',
  };
}

export enum ShapeTypeEnum {
  Circle = 'circle',
  EmptyCircle = 'emptyCircle',
  Square = 'square',
  EmptySquare = 'emptySquare',
  Rectangle = 'roundRect',
  EmptyRoundedRectangle = 'emptyRoundRect',
  Triangle = 'triangle',
  EmptyTriangle = 'emptyTriangle',
  Diamond = 'diamond',
  EmptyDiamond = 'emptyDiamond',
  Pin = 'pin',
  EmptyPin = 'emptyPin',
  Arrow = 'arrow',
  EmptyArrow = 'emptyArrow',
}

export interface ShapeType {
  value: string;
  description: string;
}

export const ShapeTypes: ShapeType[] = [
  {
    value: ShapeTypeEnum.Circle,
    description: 'Circle',
  },
  {
    value: ShapeTypeEnum.EmptyCircle,
    description: 'Empty Circle',
  },
  {
    value: ShapeTypeEnum.Square,
    description: 'Square',
  },
  {
    value: ShapeTypeEnum.EmptySquare,
    description: 'Empty Square',
  },
  {
    value: ShapeTypeEnum.Rectangle,
    description: 'Rectangle',
  },
  {
    value: ShapeTypeEnum.EmptyRoundedRectangle,
    description: 'Empty Rounded Rectangle',
  },
  {
    value: ShapeTypeEnum.Triangle,
    description: 'Triangle',
  },
  {
    value: ShapeTypeEnum.EmptyTriangle,
    description: 'Empty Triangle',
  },
  {
    value: ShapeTypeEnum.Diamond,
    description: 'Diamond',
  },
  {
    value: ShapeTypeEnum.EmptyDiamond,
    description: 'EmptyDiamond',
  },
  {
    value: ShapeTypeEnum.Pin,
    description: 'Pin',
  },
  {
    value: ShapeTypeEnum.EmptyPin,
    description: 'EmptyPin',
  },
  {
    value: ShapeTypeEnum.Arrow,
    description: 'Arrow',
  },
  {
    value: ShapeTypeEnum.EmptyArrow,
    description: 'Empty Arrow',
  },
];
